export default __webpack_public_path__ + "084d6c535766da746d4cb04243762ee1.webp";